var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.empty)?_c('div',{staticClass:"editor-view-wrapper",domProps:{"innerHTML":_vm._s(_vm.content)}}):_c('div',{staticClass:"empty-page"},[_vm._v(" "+_vm._s(_vm.emptyText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }